import { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { useAuthStatus } from '../auth-status';

type AuthRequiredWidgetProps = {
  children: ReactNode | ReactNode[];
};

export const AuthRequiredWidget = observer(
  ({ children }: AuthRequiredWidgetProps) => {
    const authStatus = useAuthStatus();

    return authStatus.isAuthRequired ? <>{children}</> : null;
  }
);
